export default {
  init() {
    // JavaScript to be fired on all pages


const tabsNav = document.querySelectorAll('.projects-nav ul li');
const tabsContents = document.querySelectorAll('.projects-content > div');

for (let i = 0; i < tabsNav.length; i++) {
  tabsNav[i].addEventListener('click', function () {
    openTabs(i);
  }, true);
}

function openTabs(index) {
  for(let i = 0; i < tabsNav.length; i++) {
    tabsNav[i].classList.remove('active');
  }

  for(let i = 0; i < tabsContents.length; i++) {
    tabsContents[i].classList.remove('active');
  }

  tabsContents[index].classList.add('active');
  tabsNav[index].classList.add('active');
}

(function initTab(start) { openTabs(start) }(0));

$(document).ready(function() {

    $('.slider-review').slick({
        appendArrows: $('.slider-review-arrow'),
        prevArrow: '<span class="slick-prev">' +
          '<svg class="icon angle-left"><use xlink:href="#angle-left"></use></svg>' +
        '</span>',
        nextArrow: '<span class="slick-next">' +
          '<svg class="icon angle-right"><use xlink:href="#angle-right"></use></svg>' +
        '</span>',
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                },
            },
        ],
    });
    
  document.addEventListener( 'wpcf7mailsent', function() {
		$('#sendSuccessModal').modal('show');
		// Google Analytics
          window.dataLayer.push(
            {'event': 'send_form_general'}
          );
          // Facebook Pixel
         // fbq('track', 'Lead');
          // Quora Pixel
         // qp('track', 'Generic');
	}, false );

	document.addEventListener( 'wpcf7mailfailed ', function() {
		$('#sendErrorModal').modal('show');
	}, false );

    $('.akkordeon li > p').click(function(){
        if(!$(this).hasClass('active')){
            $('ul.akkordeon li > p').removeClass('active').next('div').stop().slideUp();
            $(this).addClass('active');
            $(this).next('div').stop().slideDown(200);
        } else {
            $(this).removeClass('active').next('div').stop().slideUp();
        }
    });

    var copyright = '© '+ (new Date()).getFullYear() + ' ';
    $('.copyright_footer').prepend(copyright);
});

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js